import { API_JWT_BASE_URL } from '../http'

export const IMPORT_PROGRAMMING_FILE_API = `${API_JWT_BASE_URL}/programmingfiles/import`

export const PROGRAMMING_FILE_QUERY_KEYS = {
	IMPORT_PROGRAMMING_FILE: 'IMPORT_PROGRAMMING_FILE'
}
